import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';

import Heading from '@/src/shared/components/Heading';
import { bp, colors } from '@/styles';

const style = {
  panelWrapper: css`
    padding-top: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid ${colors.accentGrayLight};
    &:first-child {
      padding-top: 0px;
    }
    &:last-child {
      border-bottom: 0;
    }
  `,
  panel: css`
    max-width: 630px;
    padding-left: 32px;
    &:not(:first-child) {
      background: red;
    }
    @media ${bp.lg} {
      padding-left: 100px;
    }
  `,
  subheading: css`
    color: ${colors.secondaryGray};
    font-weight: bold;
    font-size: 1rem;
    line-height: 1.67;
  `,
  subheadingWrapper: css`
    margin-top: 4px;
    margin-bottom: 4px;
  `,
  panelTitle: css`
    font-size: 1.2rem;
  `,
  panelParagraph: css`
    font-size: 1.6rem;
    line-height: 1.75;
    color: ${colors.secondaryGray};
    margin-bottom: 0px;
  `,
};

const AccordionPanel = ({ contentData }) => {
  return (
    <div css={style.panelWrapper}>
      <div css={style.panel}>
        <Heading
          css={style.panelTitle}
          tag="a"
          weight="bold"
          theme="primaryBlue"
          href={contentData.Url}
        >
          {contentData.Title}
        </Heading>
        <div css={style.subheadingWrapper}>
          <p css={style.subheading}>{contentData.SubHeading}</p>
        </div>
        {contentData.Paragraph && <p>{contentData.Paragraph}</p>}
      </div>
    </div>
  );
};

AccordionPanel.propTypes = {};

export default AccordionPanel;
